module.exports = __webpack_public_path__ + "img/Girl_010031.f61f14a2.png";